module.exports = __webpack_public_path__ + "img/bg13.e1d21324.jpg";